import { FormControl, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from 'react'
import { Controller } from 'react-hook-form'

export default function DateForm({ label, control, dynamicField, errors, required, disabled, minDate, maxDate, hasHour }) {

  return (
    <div>
      <FormControl fullWidth>
        <Controller
          name={dynamicField} // Replace "selectedDate" with the appropriate name for your form field
          control={control}
          rules={{
            required: {
              value: required,
              message: 'This field is required',
            },


            validate: {
              validDate: (value) => {
                const selectedDate = new Date(value);
                const minDateValue = new Date(minDate);
                const maxDateValue = new Date(maxDate);

                if (isNaN(selectedDate)) {
                  return 'Please enter a valid date'; // Geçersiz bir tarih girildiğinde hata mesajı döndürülür
                }

                if (selectedDate < minDateValue || selectedDate > maxDateValue) {
                  const minDateFormatted = `${minDateValue.getDate()}-${minDateValue.getMonth() + 1}-${minDateValue.getFullYear()}`;
                  const maxDateFormatted = `${maxDateValue.getDate()}-${maxDateValue.getMonth() + 1}-${maxDateValue.getFullYear()}`;
                  return `Date should be between ${minDateFormatted} and ${maxDateFormatted}`; // Belirtilen formatlarda hata mesajı
                }

                return true;
              },
            },

          }}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                minDate={minDate}
                maxDate={maxDate}
                {...field}
                disabled={disabled}
                componentsProps={{
                  actionBar: { actions: ['clear', 'today'] },
                }}
                value={field.value || null}
                onChange={(newValue) => field.onChange(newValue)}
                renderInput={(params) => <TextField {...params} label={label} size="small" fullWidth

                  sx={disabled && { backgroundColor: 'hsl(0, 0%, 95%)' }}
                  error={!!errors?.[dynamicField]}
                  helperText={errors?.[dynamicField]?.message || ''}
                />}
                inputFormat={hasHour ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"}
              />
            </LocalizationProvider>
          )}
        />
      </FormControl>
    </div>
  )
}
